import React, { useState } from "react";
import {
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
  Button,
  Breadcrumbs,
  Box,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Checkbox,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useTheme } from "@emotion/react";

const AndroidAppAccess = () => {
  const them = useTheme();
  const isMobile = useMediaQuery(them.breakpoints.down("sm"));
  const [formMode, setFormMode] = useState("initial");
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");

  // Hardcoded table data
  const [tableData, setTableData] = useState([
    {
      id: 1,
      deviceSN: "B-26W8L52-350B3C64",
      machineIP: "192.168.100.109",
      fullName: "John Doe",
      mobileNumber: "1234567890",
      registerStatus: "Pending",
    },
    {
      id: 2,
      deviceSN: "C-37X9M63-461D4E75",
      machineIP: "192.168.100.110",
      fullName: "Jane Smith",
      mobileNumber: "2345678901",
      registerStatus: "Approved",
    },
    {
      id: 3,
      deviceSN: "D-48Y0N74-572E5F86",
      machineIP: "192.168.100.111",
      fullName: "Bob Johnson",
      mobileNumber: "3456789012",
      registerStatus: "Hold",
    },
    {
      id: 4,
      deviceSN: "E-59Z1P85-683F6G97",
      machineIP: "192.168.100.112",
      fullName: "Alice Brown",
      mobileNumber: "4567890123",
      registerStatus: "Rejected",
    },
    {
      id: 5,
      deviceSN: "F-60A2Q96-794G7H08",
      machineIP: "192.168.100.113",
      fullName: "Charlie Wilson",
      mobileNumber: "5678901234",
      registerStatus: "Pending",
    },
    {
      id: 6,
      deviceSN: "G-71B3R07-805H8I19",
      machineIP: "192.168.100.114",
      fullName: "Diana Taylor",
      mobileNumber: "6789012345",
      registerStatus: "Approved",
    },
  ]);

  const [formData, setFormData] = useState({
    deviceSN: "",
    machineIP: "",
    fullName: "",
    mobileNumber: "",
    registerStatus: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddNew = () => {
    setFormMode("add");
    setSelectedRow(null);
    setFormData({
      deviceSN: "",
      machineIP: "",
      fullName: "",
      mobileNumber: "",
      registerStatus: "",
    });
  };

  const handleCancel = () => {
    setFormMode("initial");
    setSelectedRow(null);
    setFormData({
      deviceSN: "",
      machineIP: "",
      fullName: "",
      mobileNumber: "",
      registerStatus: "",
    });
  };

  const handleRowClick = (row) => {
    setSelectedRow(row.id);
    setFormData(row);
    setFormMode("edit");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0);
  };

  const filteredData = tableData.filter((row) =>
    Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const onSubmit = () => {
    // Handle form submission
  };

  const onUpdate = () => {
    // Handle form update
  };

  return (
    <Container maxWidth={isMobile ? "xs" : "lg"}>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12}>
          <Box sx={{ mt: 1, mb: 2 }}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                to="/dashboard/dashbordhome"
                style={{ textDecoration: "none", color: "primary" }}
              >
                Home
              </Link>
              <Typography color="textPrimary">
                Register HHT Device Status Update
              </Typography>
            </Breadcrumbs>
          </Box>

          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
              Register HHT Device Status Update (* Fields Are Mandatory)
            </Typography>

            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Device SN"
                  name="deviceSN"
                  fullWidth
                  size="small"
                  value={formData.deviceSN}
                  onChange={handleInputChange}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Machine IP"
                  name="machineIP"
                  fullWidth
                  size="small"
                  value={formData.machineIP}
                  onChange={handleInputChange}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Full Name"
                  name="fullName"
                  fullWidth
                  size="small"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Mobile Number"
                  name="mobileNumber"
                  fullWidth
                  size="small"
                  value={formData.mobileNumber}
                  onChange={handleInputChange}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Register Status(*)"
                  name="registerStatus"
                  fullWidth
                  size="small"
                  value={formData.registerStatus}
                  onChange={handleInputChange}
                  disabled={formMode === "initial"}
                >
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Approved">Approved</MenuItem>
                  <MenuItem value="Hold">Hold</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                </TextField>
              </Grid>
            </Grid>

            <Grid container justifyContent="flex-end" mt={1} spacing={1}>
              {formMode === "initial" && (
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleAddNew}
                  >
                    Add New
                  </Button>
                </Grid>
              )}
              {formMode === "add" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onSubmit}>
                      Submit
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
              {formMode === "edit" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onUpdate}>
                      Update
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>

            <Box mt={3}>
              <Box
                sx={{
                  mb: 2,
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: isMobile ? "flex-start" : "flex-end", // Change this to 'flex-end' for right alignment
                  alignItems: isMobile ? "stretch" : "flex-start", // Use 'flex-start' to align items to the top
                  gap: 2,
                }}
              >
                <TextField
                  label="Search"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={searchTerm}
                  onChange={handleSearchChange}
                  sx={{ mb: 2, width: isMobile ? "100%" : "auto" }} // Adjust width as needed
                />
              </Box>

              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Device SN</TableCell>
                      <TableCell>Machine IP</TableCell>
                      <TableCell>Full Name</TableCell>
                      <TableCell>Mobile Number</TableCell>
                      <TableCell>Register Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => (
                        <TableRow
                          key={row.id}
                          hover
                          onClick={() => handleRowClick(row)}
                          selected={selectedRow === row.id}
                        >
                          <TableCell>{row.deviceSN}</TableCell>
                          <TableCell>{row.machineIP}</TableCell>
                          <TableCell>{row.fullName}</TableCell>
                          <TableCell>{row.mobileNumber}</TableCell>
                          <TableCell>{row.registerStatus}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AndroidAppAccess;
